import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

import { useSetErrorMutation } from "../../app/services/auth-rtk.service";

export default function Custom500() {
  const { t } = useTranslation();
  const error = useRouteError();

  const [setError] = useSetErrorMutation();

  useEffect(() => {
    const str: string = (error as any)?.stack?.toString();

    if (str?.includes("dynamically imported")) {
      window?.location?.reload();
    }

    if (!window.location.hostname.includes("localhost")) {
      setError({
        error: String(str),
        message: String(error) as string
      }).unwrap();
    }
  }, [error]);

  return (
    <div className="tw-w-full tw-h-full tw-px-4 tw-pt-4 tw-pb-10 tw-bg-gray-50 tw-shadow-[0px_3px_5px_0px_rgba(0,0,0,0.08)] tw-flex-col tw-justify-center tw-items-center tw-inline-flex">
      <div className="tw-w-full  tw-py-10 tw-bg-gray-50 tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-flex">
        <div className="tw-w-full tw-flex-col tw-justify-start tw-items-center tw-gap-4 tw-flex">
          <div className="tw-w-full tw-h-64 lg:tw-h-96 tw-relative">
            <div className="tw-z-1 tw-left-0 tw-top-[30px] lg:tw-top-[100px] tw-text-9xl lg:tw-text-[288px] lg:tw-text-[388px]  tw-absolute tw-w-full   tw-text-center tw-text-gray-200 tw-font-bold tw-font-['Lexend'] tw-leading-10">
              500
            </div>
            <div className="tw-z-99 tw-left-0 tw-top-0 lg:tw-top-[10.20px] tw-absolute tw-w-full tw-h-48 tw-flex-col tw-justify-start tw-items-start lg:tw-gap-6 tw-inline-flex">
              <span className="tw-block lg:tw-hidden tw-self-stretch  tw-text-center tw-text-gray-800 tw-text-4xl tw-font-bold tw-font-['Lexend'] tw-leading-10">
                {t("site/500/mobileTitle")}
              </span>
              <span className="tw-block lg:tw-hidden tw-text-center  tw-self-stretch  tw-text-gray-700 tw-text-lg tw-font-['Lexend'] tw-leading-7">
                {t("site/500/mobileDescription")}
              </span>
              <span className="tw-hidden lg:tw-block  lg:tw-px-64 tw-self-stretch tw-text-center tw-text-gray-800 tw-text-3xl  lg:tw-text-6xl tw-font-bold tw-font-['Lexend']">
                {t("site/500/desktopTitle")}
              </span>
              <span className="tw-hidden lg:tw-block  lg:tw-px-48 tw-self-stretch tw-text-center tw-text-gray-800 tw-text-2xl lg:tw-text-4xl tw-font-bold tw-font-['Lexend']">
                {t("site/500/desktopDescription1")}
              </span>
            </div>
          </div>
        </div>
        <div className="tw-hidden lg:tw-block tw-self-stretch tw-text-center tw-text-gray-700 tw-text-xl lg:tw-text-2xl tw-font-semibold tw-font-['Lexend'] tw-leading-loose">
          {t("site/500/desktopDescription2")}
        </div>
      </div>
    </div>
  );
}
